import React from "react";
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormSH from '../../../../library/form/components/FormSH';
// import SarasDnDList from '../../../../library/hooks/bdnd/SarasDnDList';
import SarasDnDList from '../../../../library/hooks/dndkit/SarasDnDList';
import FormWrapper from "../../../../library/form/components/FormWrapper";
import DashLaneItem from "./DashLaneItem";

const DashViewByGroupRow = (props) => {
    const { formObject, rowKey, viewData, sarasDnDManager, dashRowId, reloadData, groupClass, deviceInfo } = props;
    const laneClass = groupClass || "uiTaskDashRow";
    const groupTitleData = formObject.getFormData(rowKey, "", "groupTitle");
    const groupTitleTooltip = groupTitleData?.dataList?.valS || groupTitleData?.valF || groupTitleData?.val || "";

    // console.log("worker 1", viewData);

    const renderDashGroupRow = (rowId, index) => {
        let row = sarasDnDManager.getGroupRow(viewData, rowId);

        let DynamicComponent = formObject.viewMap[row.viewKey];

        if(!DynamicComponent)
        {
            DynamicComponent = formObject.viewMap["vTaskDashRow"];
        }

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return (
                <DashLaneItem rowKey={rowId} index={index} key={index} isSortMode={sarasDnDManager.isSortMode()}>
                    <DynamicComponent formObject={formObject} index={index} rowKey={rowId} viewData={row} dashRowId={dashRowId}
                        groupKey={rowKey} isSortMode={sarasDnDManager.isSortMode()}
                    />
                </DashLaneItem>
            )
        }
    }

    return (
        <div
            style={{
                display: "flex",
                alignItems: "stretch"
            }}
            className={`group-row uiDashBoardLaneShell ${laneClass}`}
        >
        <div
            id="dashContainer"
            className="uiDashboardGroup uiDashViewD uiDashBoardLaneColumn"
            style={{
                minWidth:"185px",
                display: "flex",
                flexDirection: "column"
            }}
        >
            <FormWrapper useColStyle={true} wrapperClass="uiHeaderBlock" customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: "groupTitle" }} >
                <div className="uiBlock uiContentCenter" style={{margin:"0"}}>
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "groupTitle" }} className='uiBlock uiDashGroupTitle' tooltip={groupTitleTooltip} />
                </div>
            </FormWrapper>
            <div
                className="uiContentBlock"
                style={{
                    marginTop: "0px",
                    minWidth:"160px",
                    width:"100%",
                    flex: "1 1 auto",
                    overflowY: "auto",
                    overflowX: "hidden"
                }}
            >
                <SarasDnDList groupKey={rowKey} sarasDnDManager={sarasDnDManager} >
                    {
                        sarasDnDManager.getGroupRowsKeys(viewData).map((rowId,index)=>(
                            renderDashGroupRow(rowId,index)
                        ))
                    }
                </SarasDnDList>
            </div >
            <FormWrapper wrapperClass={`uiFooterBlock${deviceInfo.isTabletWidthOrLess ? " uiDashGroupFooterTouch" : ""}`} customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: "footerContainer" }} >
                <div className="uiFlexBox3">
                    <FormButton formObject={formObject} rowKey={rowKey}  className="dash-print uiPrint uiDashSHLink" tooltip="Activity Log Report"
                        starIcon="timesheet"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        action={{ actionId: "print",  paramName: "printActivityLog", actionMessage:"Creating Log Report",
                        actionParam: { cGroup: '%dataList.groupId', dashprint:'%dataList.dashprint', rptName:'%dataList.rptName',dshv_rowId:dashRowId }, 
                        containerKey: "popup" }}
                    />
                    <FormButton formObject={formObject} rowKey={rowKey}  className="dash-print uiPrint uiDashSHLink" tooltip="Call Report"
                        starIcon="task"
                        onlyIcon={true}
                        starIconClassName="uiLink uiIcon"
                        action={{ actionId: "print",  paramName: "printCallReport", actionMessage:"Creating Call Report",
                        actionParam: { cGroup: '%dataList.groupId', dashprint:'%dataList.dashprint', rptName:'%dataList.rptName',dshv_rowId:dashRowId }, 
                        containerKey: "popup" }}
                    />
                    <FormSH formObject={formObject} rowKey={rowKey} style={{}}
                        action={{ actionId: "new", paramName: "taskSH",  onModalClose:reloadData,
                        actionParam: { cGroup: '%dataList.groupId', viewCaller: "InDashboard",dshv_rowId:dashRowId, 
                        dsh_docid:formObject.masterKeys.dId, dsh_wrksid: formObject.masterKeys.wsId}, actionMessage:"Creating New Task",
                        skipMasterKey:0, containerKey: "popup" }}
                        className="uiLink uiIcon" >
                    </FormSH>
                </div>
            </FormWrapper>
        </div >
        </div>
    )
}

export default DashViewByGroupRow
